<template>
  <!-- Header -->
  <div class="slcb-toddy__header-container">
    <div class="slcb-toddy__header" v-bind:class="[isClosing ? 'slcb-toddy__header--closing' : 'slcb-toddy__header--starting']" v-if="!isDone">
      <b-container style="height: 100%">
        <b-row style="height: 100%">
          <b-col cols="12" class="slcb-toddy__header-title-container">
            <div class="slcb-toddy__header-title-child-container">
              <h1 class="slcb-toddy__header-title" v-bind:class="[isClosing ? 'slcb-toddy__header-title--closing' : 'slcb-toddy__header-title--starting']">Score Jurídico</h1>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="slcb-toddy__header slcb-toddy__header--initiate" v-bind:class="[!isDone ? 'slcb-toddy__header--initiate-fixed' : '']">
      <b-container>
        <b-row class="slcb-toddy__header-nav-title-container slcb-toddy__header-title-container--done">
          <b-col cols="12" class="slcb-toddy__header-nav-title-innercontainer">
            <div class="slcb-toddy__header-nav" v-if="stepBack && previousNodo != undefined">
              <button type="button" class="slcb-toddy__header-nav-item" v-on:click="previousStep">
                <b-img src="~@/assets/img/arrow_left.svg" alt="Flecha para esquerda"/>
              </button>
            </div>
            <span class="slcb-toddy__header-nav-title slcb-toddy__header-nav-title--done" v-bind:class="[(stepBack && previousNodo != undefined) ? 'slcb-toddy__header-nav-title--sub-left' : '']">Calcule o seu score jurídico</span>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: ['stepBack', 'previousNodo', 'isClosing', 'isDone'],
  data () { return {} },
  methods: {
    previousStep: function () {
      this.$emit('previousStep')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue